import React from 'react';
import classnames from 'classnames';

import {
  section,
  inner,
  tags,
  tagItem,
  title,
  subtitle,
  date,
} from './styles.module.scss';

const Hero = ({ data }) => {
  return (
    <section
      className={section}
      style={{
        backgroundColor: data?.webinarOnDemandHeroBackgroundColor
          ? data.webinarOnDemandHeroBackgroundColor
          : '#ebedf2',
      }}
    >
      <div className="scr-wrap">
        <div className={inner}>
          <ul className={tags}>
            {data?.webinarOnDemandHeroTags?.map((tag) => {
              return (
                <li
                  key={tag.webinarOnDemandHeroTagItem}
                  className={classnames('scr-lead', tagItem)}
                >
                  {tag.webinarOnDemandHeroTagItem}
                </li>
              );
            })}
          </ul>

          <h1 className={title}>{data?.webinarOnDemandHeroTitle}</h1>

          <p className={subtitle}>{data?.webinarOnDemandHeroDescription}</p>

          <p className={date}>{data?.webinarOnDemandHeroDate}</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
